export const useCaseLanguagesData = {
  title: "Expert professional content translation in 100+ languages",
  description:
    "We offer the most elite network of vetted and specialized business translators for exceptional accuracy.",
  languages: [
    { name: "Spanish", link: "/languages/spanish" },
    { name: "Arabic", link: "/languages/arabic" },
    { name: "French", link: "/languages/french" },
    { name: "Italian", link: "/languages/italian" },
    { name: "German", link: "/languages/german" },
    { name: "Chinese", link: "/languages/chinese" },
    { name: "Brazilian", link: "/languages/brazilian-portuguese" },
    { name: "Japanese", link: "/languages/japanese" },
  ],
  exploreText: "Explore all",
};
